import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaWhatsapp, FaAngleUp } from "react-icons/fa6";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    // هنگام تغییر مسیر صفحه، اسکرول به بالا
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    // بررسی مقدار اسکرول
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* دکمه واتساپ */}
      <Link
        to="https://wa.me/971565979684"
        target="_blank"
        className="fixed z-50 lg:right-6 bottom-16 right-2 lg:bottom-6 bg-green-600 text-white p-[8px] text-[28px] rounded-full lg:text-[40px]"
      >
        <FaWhatsapp />
      </Link>

      {/* دکمه بازگشت به بالا */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed z-50 right-2 bottom-28 lg:right-6 lg:bottom-24 bg-white text-green-600 p-[8px] text-[20px] rounded-full lg:text-[30px] shadow-md hover:bg-gray-700"
        >
          <FaAngleUp />
        </button>
      )}
    </>
  );
}